import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { PushNotificationEffects } from './+state/push-notification.effects';
import { StoreModule } from '@ngrx/store';
import { PUSH_NOTIFICATIONS_REDUCER_KEY, pushNotificationReducer } from './+state/push-notification.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(PUSH_NOTIFICATIONS_REDUCER_KEY, pushNotificationReducer),
    EffectsModule.forFeature([PushNotificationEffects])
  ]
})
export class PushNotificationsDataAccessModule {}
